module.exports = __webpack_public_path__ + "img/ico_type_date.f5ca2555.svg";